"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const faUserCircle_1 = require("@fortawesome/pro-solid-svg-icons/faUserCircle");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const faBars_1 = require("@fortawesome/pro-regular-svg-icons/faBars");
const faCommentsAlt_1 = require("@fortawesome/pro-light-svg-icons/faCommentsAlt");
const faCarMirrors_1 = require("@fortawesome/pro-light-svg-icons/faCarMirrors");
const faMinus_1 = require("@fortawesome/pro-solid-svg-icons/faMinus");
const faPlus_1 = require("@fortawesome/pro-solid-svg-icons/faPlus");
const Button_1 = __importDefault(require("../../Button"));
const Link_1 = __importDefault(require("../../Link"));
const constants_1 = require("../../../utils/constants");
const LazyHydrate_1 = __importDefault(require("../../LazyHydrate"));
const analyticsUtils_1 = require("../../../utils/analyticsUtils");
const testUtils_1 = require("../../../utils/testUtils");
const navigation_1 = require("../../../interfaces/navigation");
const styles = require('./HeaderMobile.module.scss');
const augmentHeaderNodes = (nodes) => {
    const mobileNodes = [...nodes];
    const newsNodeIndex = mobileNodes.findIndex((node) => node.type === navigation_1.NavigationType.News);
    const newsNode = mobileNodes.splice(newsNodeIndex, 1)[0];
    if (newsNode && newsNode.sections) {
        const nextNodes = newsNode.sections.map((_a) => {
            var { text, type, path, sections } = _a, rest = __rest(_a, ["text", "type", "path", "sections"]);
            return (Object.assign(Object.assign({ path,
                text,
                type }, rest), { sections: [
                    Object.assign({ path,
                        text,
                        type,
                        sections }, rest),
                ] }));
        });
        mobileNodes.splice(newsNodeIndex, 0, ...nextNodes);
    }
    return mobileNodes;
};
const headerSections = ({ nodes, selectedNavigationType, handleNavigationNodeClick, }) => augmentHeaderNodes(nodes).map((node) => {
    const isSectionOpen = node.type === selectedNavigationType;
    return (react_1.default.createElement("div", { className: styles.navigationShadow, key: node.type },
        react_1.default.createElement("div", { className: styles.navigationItem },
            react_1.default.createElement(Link_1.default, { className: styles.sectionHeading, color: "yellow", noUnderline: true, href: node.path, rel: node.rel, target: node.isOpenInNewWindow ? '_blank' : '_self', trackingAttributes: {
                    category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                    action: 'click',
                    label: node.text,
                } }, node.text),
            node.sections &&
                node.sections[0] &&
                node.sections[0].sections &&
                node.sections[0].sections.length > 0 && (react_1.default.createElement(Button_1.default, { "aria-label": `Expand ${node.type}`, className: styles.expand, appearance: "link", onClick: () => handleNavigationNodeClick(node.type) },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { className: styles.expandIcon, icon: isSectionOpen ? faMinus_1.faMinus : faPlus_1.faPlus })))),
        react_1.default.createElement("div", null, node.sections &&
            node.sections[0] &&
            node.sections[0].sections &&
            node.sections[0].sections.map((link) => (react_1.default.createElement(Link_1.default, { className: (0, classnames_1.default)(styles.section, { [styles.isSectionOpen]: isSectionOpen }), noUnderline: true, trackingAttributes: {
                    category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                    action: 'click',
                    label: node.text,
                }, "data-gtm-event-label": link.text.toLowerCase(), href: link.path, rel: link.rel, key: link.path, target: link.isOpenInNewWindow ? '_blank' : '_self' },
                react_1.default.createElement("div", { className: styles.linkNode },
                    react_1.default.createElement("span", null, link.text))))))));
});
const HeaderMobile = ({ accountLink, isUserStatusLoading, isAuthenticated, loginLink, nodes, userName, }) => {
    const [isMenuOpen, setIsMenuOpen] = (0, react_1.useState)(false);
    const [selectedNavigationType, setSelectedNavigationType] = (0, react_1.useState)(undefined);
    const handleMenuClick = (0, react_1.useCallback)(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        document.body.classList.toggle(styles.disableScroll);
        setIsMenuOpen(!isMenuOpen);
    }, [isMenuOpen]);
    const handleNavigationNodeClick = (navigationType) => {
        const nextNavigationType = navigationType !== selectedNavigationType ? navigationType : undefined;
        setSelectedNavigationType(nextNavigationType);
    };
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.header, styles.underline) },
        react_1.default.createElement("div", { className: styles.headerPadding },
            react_1.default.createElement("div", { className: styles.flex },
                react_1.default.createElement(Link_1.default, { trackingAttributes: {
                        action: navigation_1.AnalyticsActionHeaderType.Logo,
                        category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                    }, href: `/${constants_1.Pages.Homepage}` },
                    react_1.default.createElement("img", { alt: "PistonHeads", src: "/static-assets/images/logo-smiley-with-text.17112021.svg", className: styles.logo })),
                react_1.default.createElement("div", { className: styles.spacer }),
                react_1.default.createElement(Button_1.default, Object.assign({ color: "black", className: styles.icon, classNameForText: styles.iconPosition, href: `/${constants_1.Pages.SearchResultsPage}`, appearance: "link", trackingAttributes: {
                        category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                        action: 'click',
                        label: 'logo-classifieds',
                    } }, (0, testUtils_1.getDataTypeAttribute)({ typeId: 'header-mobile-nav-button-classifieds' })),
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faCarMirrors_1.faCarMirrors, className: styles.blackColor, title: "Buy" }),
                    react_1.default.createElement("div", { className: styles.iconText }, "Buy")),
                react_1.default.createElement(Button_1.default, Object.assign({ color: "black", className: styles.icon, classNameForText: styles.iconPosition, href: "/gassing/", appearance: "link", trackingAttributes: {
                        category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                        action: 'click',
                        label: 'logo-forum',
                    } }, (0, testUtils_1.getDataTypeAttribute)({ typeId: 'header-mobile-nav-button-forum' })),
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faCommentsAlt_1.faCommentsAlt, className: styles.blackColor, title: "Forum" }),
                    react_1.default.createElement("div", { className: styles.iconText }, "Forum")),
                react_1.default.createElement(Button_1.default, Object.assign({ color: "black", className: (0, classnames_1.default)(styles.icon, styles.menuIcon), classNameForText: styles.iconPosition, onClick: handleMenuClick, appearance: "link", trackingAttributes: {
                        category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                        action: 'click',
                        label: 'logo-menu',
                    } }, (0, testUtils_1.getDataTypeAttribute)({ typeId: 'header-mobile-nav-button-menu' })),
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faBars_1.faBars, className: styles.blackColor, title: "Menu" }),
                    react_1.default.createElement("div", { className: styles.iconText }, "Menu")))),
        react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.navigationDropdown, {
                [styles.navigationDropdownOpen]: isMenuOpen,
            }) },
            react_1.default.createElement(LazyHydrate_1.default, { whenVisible: true },
                react_1.default.createElement(Button_1.default, { className: (0, classnames_1.default)(styles.closeVoid, { [styles.closeVoidOpen]: isMenuOpen }), type: "button", onClick: handleMenuClick }),
                react_1.default.createElement("nav", { className: (0, classnames_1.default)(styles.navigation, { [styles.navigationOpen]: isMenuOpen }) },
                    react_1.default.createElement("div", { className: styles.navigationShadow },
                        react_1.default.createElement("div", { className: styles.navigationItem },
                            react_1.default.createElement(Link_1.default, { className: styles.sectionHeading, color: "yellow", noUnderline: true, href: isAuthenticated ? accountLink : loginLink, trackingAttributes: {
                                    category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                                    action: 'click',
                                    label: isAuthenticated ? 'username' : 'login',
                                } },
                                react_1.default.createElement("div", { className: styles.whiteSpaceNoWrap },
                                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faUserCircle_1.faUserCircle, className: styles.authenticatedIcon }),
                                    !isUserStatusLoading && (isAuthenticated ? `${userName}` : 'Sign in')))),
                        headerSections({
                            handleNavigationNodeClick,
                            nodes,
                            selectedNavigationType,
                        })))))));
};
exports.default = HeaderMobile;
//# sourceMappingURL=HeaderMobile.js.map